module.exports = __webpack_public_path__ + "static/media/cancellations-noshows-modal.71780930.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cancellations-noshows-modal.jpg
// module id = 1045
// module chunks = 0